module.exports = __webpack_public_path__ + "img/workbench_icon9.81101eba.svg";